<template lang="pug">
server-data(
  :key="currentPage"
  :method="fetchMethod"
  :serialize-data-items="serializeData"
  :start-loading-value="true"
  v-slot="{ serverData: items, loading, pagination, hasMore }"
)
  .d-flex.flex-column.bordered-container
    template(v-if="loading")
      text-loader
    template(v-else)
      template(v-if="items.length")
        slot(name="prepend-items")
        template(v-for="(item, index) in items")
          list-item(
            :key="index"
            :item="item"
            :size="itemsSize"
          )
            template(#content)
              slot(
                name="item--content"
                :item="item"
              )
            template(#caption)
              slot(
                name="item--caption"
                :item="item"
              )
            template(#action)
              slot(
                name="item--actions"
                :item="item"
              )
        slot(name="append-items")

        template(v-if="enablePagination")
          v-divider
          app-pagination-controls.pa-5(
            v-model="currentPage"
            :length="pagination.total"
          )
      template(v-else)
        .text-center.pa-4 Здесь пока ничего нет...
</template>

<script>
import AppPaginationControls from './controls/AppPaginationControls.vue';
import ListItem from './ListItem.vue';

export default {
  name: 'DataList',
  components: {
    ListItem,
    AppPaginationControls,
  },
  props: {
    method: {
      type: Function,
      required: true,
    },
    serializeData: {
      type: Function,
      required: true,
    },
    perPage: {
      type: [Number, String],
      default: 3,
    },
    enablePagination: {
      type: Boolean,
      default: true,
    },
    itemsSize: {
      type: String,
      default: '',
    },
  },
  data() {
    return {
      currentPage: 1,
    };
  },
  computed: {},
  watch: {},
  created() {},
  methods: {
    fetchMethod() {
      const params = {
        page: this.currentPage,
        'per-page': this.perPage,
      };

      return this.method(params);
    },
  },
};
</script>
